import React from 'react';
import {
  all,
  takeLatest,
  takeEvery,
  put,
  call,
  fork,
  cancel,
  select,
  take,
  race,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import axios from 'axios';
import cep from 'cep-promise';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  collection,
  getDocs,
} from 'firebase/firestore';
import {
  getDatabase,
  ref as dbRef,
  get,
  child,
  onValue,
  update,
  query as dbQuery,
  orderByChild,
  startAt,
  endAt,
} from 'firebase/database';
import moment from 'moment-timezone';
import { v1 as uuidv1 } from 'uuid';
import actions from './actions';
import authActions from '../auth/actions';
import appActions from '../app/actions';
import { getWalletOwnerId } from './selectors';
import notification from '../../components/notification';

const ROOT_URL = process.env.REACT_APP_CLOUD_FUNCTIONS_ROOT_URL;

const getUserFromStore = (state) => state.Auth.user;

const getMainUserFromStore = (state) => state.Auth.mainUser;

const getUnifiedFromStore = (state) => state.Auth.unified;

const getSelectedAddressFromStore = (state) => state.App.selectedAddress;

// const getIsProfessionalFromStore = (state) => state.Auth.professional;

const getIsHealthProfessionalFromStore = (state) => state.Auth.healthProfessional;

// function getProfessionalUid(mainUser) {
//   if (mainUser) return mainUser;
//   const auth = getAuth();
//   return auth.currentUser?.uid;
// }

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function getIdToken() {
  const auth = getAuth();
  const { currentUser } = auth;
  return currentUser.getIdToken();
}

// function fetchAsaasAccountFromFirestore(professionalUid) {
//   const db = getFirestore();
//   const docRef = doc(db, `professionals/${professionalUid}/asaas/${professionalUid}`);
//   return getDocFromServer(docRef);
// }

function fetchAsaasAccountFromFirestore(mainUser) {
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const db = getFirestore();
  const colRef = collection(db, 'professionals', uid, 'asaas');
  return getDocs(colRef);
}

export function* getAsaasAccountRequest() {
  yield takeLatest([
    authActions.LOGIN_SUCCESS,
    actions.LOAD_ASAAS_ACCOUNT_REQUEST,
  ], function* () {
    try {
      // const user = yield select(getUserFromStore);
      const mainUser = yield select(getMainUserFromStore);
      // const professional = yield select(getIsProfessionalFromStore);
      // if (!professional) return;

      const snapshotResult = yield call(fetchAsaasAccountFromFirestore, mainUser);
      const usersObj = {};
      snapshotResult.forEach((docSnap) => {
        usersObj[docSnap.id] = {
          ...docSnap.data(),
        };
      });
      yield put({
        type: actions.LOAD_ASAAS_ACCOUNT_SUCCESS,
        payload: usersObj,
      });
      // if (docSnap.exists()) {
      //   yield put({
      //     type: actions.LOAD_ASAAS_ACCOUNT_SUCCESS,
      //     payload: {
      //       professionalUid: user.uid,
      //       accountData: docSnap.data(),
      //     },
      //   });
      // }
    } catch (error) {
      // Conta não existe ainda — sem tratamento necessário
    }
  });
}

function callSetupAsaasAccount(formData, idToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    formData,
  };
  return axios.post(
    `${ROOT_URL}/asaasCreateSubaccount`,
    bodyParameters,
    config,
  );
}

export function* setupAsaasAccountRequest() {
  yield takeLatest(actions.SETUP_ASAAS_ACCOUNT_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const healthProfessional = yield select(getIsHealthProfessionalFromStore);
      if (mainUser && !healthProfessional) {
        const msg = 'A conta de pagamento no Asaas deve ser criada pelo próprio profissional, no login dele.';
        notification('error', msg);
        yield put({ type: actions.SETUP_ASAAS_ACCOUNT_ERROR, payload: msg });
        return;
      }

      yield call(callSetupAsaasAccount, action.payload, idToken);

      // O backend grava o doc antes de responder — poll curto cobre atraso de leitura
      const user = yield select(getUserFromStore);
      const professionalUid = user?.uid;
      for (let attempt = 0; attempt < 8; attempt += 1) {
        yield put({ type: actions.LOAD_ASAAS_ACCOUNT_REQUEST });
        yield race({
          loaded: take(actions.LOAD_ASAAS_ACCOUNT_SUCCESS),
          timeout: call(sleep, 3000),
        });
        const accounts = yield select((state) => state.Asaas.accounts);
        if (accounts?.[professionalUid]?.subaccountId) break;
        yield call(sleep, 2000);
      }
    } catch (error) {
      console.warn(error);
      const errors = error?.response?.data?.errors;
      const errorDescriptions = Array.isArray(errors) && errors.length > 0
        ? (
          <ul style={{ margin: 0, paddingLeft: 16 }}>
            {errors.map((e) => <li key={uuidv1()}>{e.description}</li>)}
          </ul>
        )
        : null;
      notification('error', 'Erro ao criar conta. Tente novamente.', errorDescriptions);
      yield put({ type: actions.SETUP_ASAAS_ACCOUNT_ERROR, payload: errorDescriptions || 'Erro ao criar conta. Tente novamente.' });
    }
  });
}

function callDiscardRejectedAccount(idToken) {
  return axios.post(
    `${ROOT_URL}/asaasDiscardRejectedSubaccount`,
    {},
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* discardRejectedAccountRequest() {
  yield takeLatest(actions.DISCARD_REJECTED_ACCOUNT_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      yield call(callDiscardRejectedAccount, idToken);
      yield put({ type: actions.DISCARD_REJECTED_ACCOUNT_SUCCESS });
      notification('success', 'Conta descartada. Você já pode refazer o cadastro.');
      yield put({ type: actions.LOAD_ASAAS_ACCOUNT_REQUEST });
    } catch (error) {
      const message = error?.response?.data?.error || 'Não foi possível descartar a conta.';
      notification('error', message);
      yield put({ type: actions.DISCARD_REJECTED_ACCOUNT_ERROR, payload: message });
    }
  });
}

function callGetAsaasAccountStatus(idToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {};
  return axios.post(
    `${ROOT_URL}/asaasGetAccountStatus`,
    bodyParameters,
    config,
  );
}

export function* getAsaasAccountStatusRequest() {
  yield takeLatest(actions.GET_ASAAS_ACCOUNT_STATUS_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const user = yield select(getUserFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const healthProfessional = yield select(getIsHealthProfessionalFromStore);
      if (mainUser && !healthProfessional) {
        return;
      }

      const response = yield call(callGetAsaasAccountStatus, idToken);
      const {
        kycStatus, kycCheckedAt, detailedStatus, pendingDocuments,
        commercialInfoExpiration,
      } = response.data;

      yield put({
        type: actions.GET_ASAAS_ACCOUNT_STATUS_SUCCESS,
        payload: {
          professionalUid: user.uid,
          kycStatus,
          kycCheckedAt,
          detailedStatus,
          pendingDocuments,
          rejectReasons: pendingDocuments?.rejectReasons || null,
          commercialInfoExpiration: commercialInfoExpiration || null,
        },
      });
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao verificar status.';
      notification('error', message);
      yield put({ type: actions.GET_ASAAS_ACCOUNT_STATUS_ERROR, payload: message });
    }
  });
}

export function* searchZipCodeRequest() {
  yield takeLatest(actions.SEARCH_ZIP_CODE_REQUEST, function* (action) {
    try {
      const response = yield call(cep, action.payload);
      yield put({
        type: actions.SEARCH_ZIP_CODE_SUCCESS,
        payload: {
          address: response.street || '',
          province: response.neighborhood || '',
          city: response.city || '',
          state: response.state || '',
        },
      });
    } catch (error) {
      yield put({ type: actions.SEARCH_ZIP_CODE_SUCCESS, payload: null });
    }
  });
}

function fetchPublicFees() {
  return axios.get(`${ROOT_URL}/asaasGetPublicFees`);
}

export function* getAsaasFeesRequest() {
  yield takeLatest(actions.LOAD_ASAAS_FEES_REQUEST, function* () {
    try {
      const response = yield call(fetchPublicFees);
      yield put({
        type: actions.LOAD_ASAAS_FEES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: actions.LOAD_ASAAS_FEES_ERROR });
    }
  });
}

function callCancelAsaasCharge(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasCancelCharge`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* cancelAsaasChargeRequest() {
  yield takeLatest(actions.CANCEL_ASAAS_CHARGE_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const addressId = yield select(getSelectedAddressFromStore);
      const { chargeKey } = action.payload;
      const response = yield call(callCancelAsaasCharge, { chargeKey, addressId }, idToken);
      // Carnê com parcela paga: o backend cancela só as restantes e a cobrança segue viva
      const mode = response?.data?.mode || 'full';
      yield put({
        type: actions.CANCEL_ASAAS_CHARGE_SUCCESS,
        payload: { chargeKey, mode },
      });
      notification('success', mode === 'remaining' ? 'Parcelas restantes canceladas.' : 'Cobrança cancelada.');
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao cancelar cobrança.';
      notification('error', message);
      yield put({ type: actions.CANCEL_ASAAS_CHARGE_ERROR, payload: message });
    }
  });
}

function callRefundAsaasCharge(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasRefundCharge`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* refundAsaasChargeRequest() {
  yield takeLatest(actions.REFUND_ASAAS_CHARGE_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const addressId = yield select(getSelectedAddressFromStore);
      const payload = { ...action.payload, addressId };
      yield call(callRefundAsaasCharge, payload, idToken);
      yield put({ type: actions.REFUND_ASAAS_CHARGE_SUCCESS });
      notification('success', 'Estorno solicitado com sucesso.');
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao estornar cobrança.';
      notification('error', message);
      yield put({ type: actions.REFUND_ASAAS_CHARGE_ERROR, payload: message });
    }
  });
}

function callCheckRefundStatus(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasCheckRefundStatus`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* checkRefundStatusRequest() {
  yield takeLatest(actions.CHECK_REFUND_STATUS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const addressId = yield select(getSelectedAddressFromStore);
      const payload = { ...action.payload, addressId };
      const response = yield call(callCheckRefundStatus, payload, idToken);
      yield put({ type: actions.CHECK_REFUND_STATUS_SUCCESS, payload: response.data });
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao verificar status do estorno.';
      yield put({ type: actions.CHECK_REFUND_STATUS_ERROR, payload: message });
    }
  });
}

function createAsaasChargesChannel(addressId, mainUser, startTimestamp, endTimestamp) {
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  return eventChannel((emit) => {
    const db = getDatabase();
    const chargesRef = dbRef(db, `financial/${uid}/${addressId}/asaasCharges`);
    const constraints = [orderByChild('timestamp')];
    if (startTimestamp) constraints.push(startAt(startTimestamp));
    if (endTimestamp) constraints.push(endAt(endTimestamp));
    const queryRef = dbQuery(chargesRef, ...constraints);
    const unsubscribe = onValue(queryRef, (snap) => {
      emit(snap.val() || {});
    }, () => {
      // Erro do listener (ex.: permissão após logout): encerra o canal
      emit(END);
    });
    return unsubscribe;
  });
}

export function* loadAsaasChargesRequest() {
  yield takeLatest(actions.LOAD_ASAAS_CHARGES_REQUEST, function* (action) {
    try {
      const mainUser = yield select(getMainUserFromStore);
      const user = yield select(getUserFromStore);
      const professionalUid = user?.uid;
      const payload = action.payload || {};
      let addressId = yield select(getSelectedAddressFromStore);
      if (!addressId) {
        yield take(appActions.SELECT_ADDRESS);
        addressId = yield select(getSelectedAddressFromStore);
      }
      const startTimestamp = payload.startDate
        || moment().tz('America/Sao_Paulo').subtract(30, 'days').format('YYYY-MM-DD');
      const endTimestamp = payload.endDate || undefined;

      if (!professionalUid || !addressId) {
        yield put({ type: actions.LOAD_ASAAS_CHARGES_ERROR, payload: 'Não foi possível carregar as cobranças.' });
        return;
      }

      const channel = yield call(
        createAsaasChargesChannel,
        addressId,
        mainUser,
        startTimestamp,
        endTimestamp,
      );
      yield put({ type: actions.ASAAS_CHARGES_UPDATED, payload: {} });
      try {
        while (true) {
          // Logout fecha o canal — sem isso o listener RTDB vaza entre sessões
          const { charges, cleared } = yield race({
            charges: take(channel),
            cleared: take(authActions.CLEAR_STATES),
          });
          if (cleared) break;
          yield put({
            type: actions.ASAAS_CHARGES_UPDATED,
            payload: charges,
          });
        }
      } finally {
        channel.close();
      }
    } catch (error) {
      yield put({ type: actions.LOAD_ASAAS_CHARGES_ERROR, payload: 'Não foi possível carregar as cobranças.' });
    }
  });
}

function callGetCheckoutInfo(checkoutKey) {
  return axios.post(`${ROOT_URL}/asaasGetCheckoutInfo`, { checkoutKey });
}

export function* getCheckoutInfoRequest() {
  yield takeLatest(actions.GET_CHECKOUT_INFO_REQUEST, function* (action) {
    const { checkoutKey, silent } = action.payload;
    try {
      const response = yield call(callGetCheckoutInfo, checkoutKey);
      yield put({
        type: actions.GET_CHECKOUT_INFO_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      // Falha de polling silencioso não derruba a página
      if (silent) return;
      const msg = error?.response?.data?.message || 'Link de pagamento inválido ou expirado.';
      yield put({
        type: actions.GET_CHECKOUT_INFO_ERROR,
        payload: msg,
      });
    }
  });
}

function callValidateCheckoutCpf(checkoutKey, cpfSuffix) {
  return axios.post(`${ROOT_URL}/asaasValidateCheckoutCpf`, { checkoutKey, cpfSuffix });
}

export function* validateCheckoutCpfRequest() {
  yield takeLatest(actions.VALIDATE_CHECKOUT_CPF_REQUEST, function* (action) {
    try {
      const { checkoutKey, cpfSuffix } = action.payload;
      const response = yield call(callValidateCheckoutCpf, checkoutKey, cpfSuffix);
      yield put({
        type: actions.VALIDATE_CHECKOUT_CPF_SUCCESS,
        payload: { cpfValidatedToken: response?.data?.cpfValidatedToken || null },
      });
    } catch (error) {
      const status = error?.response?.status;
      const msg = status === 429
        ? 'Muitas tentativas. Aguarde alguns minutos e tente novamente.'
        : (error?.response?.data?.message || 'Dígitos não conferem com o cadastro. Tente novamente.');
      yield put({
        type: actions.VALIDATE_CHECKOUT_CPF_ERROR,
        payload: msg,
      });
    }
  });
}

function callAsaasCheckoutPayWithCreditCard(payload) {
  return axios.post(`${ROOT_URL}/asaasCheckoutCreateCreditCardCharge`, payload);
}

export function* asaasCheckoutPayWithCreditCardRequest() {
  yield takeLatest(actions.CREATE_PUBLIC_CHARGE_REQUEST, function* (action) {
    try {
      const cpfValidatedToken = yield select((state) => state.Asaas.cpfValidatedToken);
      const response = yield call(callAsaasCheckoutPayWithCreditCard, { ...action.payload, cpfValidatedToken });
      yield put({
        type: actions.CREATE_PUBLIC_CHARGE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.warn(error);
      const msg = 'Erro ao gerar cobrança. Tente novamente.';
      const rawError = error?.response?.data?.error;
      const desc = rawError ? (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {rawError.split('|').map((e) => <li key={uuidv1()}>{e.trim()}</li>)}
        </ul>
      ) : undefined;
      notification('error', msg, desc);
      yield put({
        type: actions.CREATE_PUBLIC_CHARGE_ERROR,
        payload: msg,
      });
    }
  });
}

function callCreateCheckoutCharge(checkoutKey, billingType, cpfValidatedToken, installmentCount) {
  return axios.post(`${ROOT_URL}/asaasCreateCharge`, {
    checkoutKey, billingType, cpfValidatedToken, installmentCount,
  });
}

export function* createCheckoutChargeRequest() {
  yield takeLatest(actions.CREATE_CHECKOUT_CHARGE_REQUEST, function* (action) {
    try {
      const { checkoutKey, billingType, installmentCount = 1 } = action.payload;
      const cpfValidatedToken = yield select((state) => state.Asaas.cpfValidatedToken);
      const response = yield call(callCreateCheckoutCharge, checkoutKey, billingType, cpfValidatedToken, installmentCount);
      yield put({
        type: actions.CREATE_CHECKOUT_CHARGE_SUCCESS,
        payload: { billingType, chargeData: response.data.chargeData },
      });
    } catch (error) {
      console.warn(error);
      const msg = 'Erro ao gerar cobrança. Tente novamente.';
      const rawError = error?.response?.data?.error;
      const desc = rawError ? (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {rawError.split('|').map((e) => <li key={uuidv1()}>{e.trim()}</li>)}
        </ul>
      ) : undefined;
      notification('error', msg, desc);
      yield put({
        type: actions.CREATE_CHECKOUT_CHARGE_ERROR,
        payload: msg,
      });
    }
  });
}

function callSimulatePayment({ value, maxInstallments, professionalId }, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasSimulatePayment`,
    {
      value,
      maxInstallments,
      professionalId,
    },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* simulateAsaasPaymentRequest() {
  const tasksByKey = {};
  yield takeEvery(actions.SIMULATE_ASAAS_PAYMENT_REQUEST, function* (action) {
    const { itemKey } = action.payload;
    if (tasksByKey[itemKey]) {
      yield cancel(tasksByKey[itemKey]);
    }
    tasksByKey[itemKey] = yield fork(function* () {
      try {
        const {
          value,
          maxInstallments,
          professional,
        } = action.payload;
        const idToken = yield call(getIdToken);
        let professionalId = professional;
        if (!professionalId) {
          const mainUser = yield select(getMainUserFromStore);
          const user = yield select(getUserFromStore);
          professionalId = mainUser || user.uid;
        }
        const response = yield call(
          callSimulatePayment,
          { value, maxInstallments, professionalId },
          idToken,
        );
        yield put({
          type: actions.SIMULATE_ASAAS_PAYMENT_SUCCESS,
          payload: {
            itemKey,
            installments: response.data.installments,
            pix: response.data.pix,
            boleto: response.data.boleto,
            pixByInstallment: response.data.pixByInstallment,
            boletoByInstallment: response.data.boletoByInstallment,
          },
        });
      } catch (error) {
        yield put({
          type: actions.SIMULATE_ASAAS_PAYMENT_ERROR,
          payload: { itemKey, error: 'Erro ao simular taxas.' },
        });
      }
    });
  });
}

function callGetAsaasBalance(idToken, { startDate, endDate } = {}, professionalId) {
  return axios.post(
    `${ROOT_URL}/asaasGetBalance`,
    { startDate, endDate, professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* loadAsaasBalanceRequest() {
  yield takeLatest(actions.LOAD_ASAAS_BALANCE_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetAsaasBalance, idToken, payload, professionalId);
      yield put({
        type: actions.LOAD_ASAAS_BALANCE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: actions.LOAD_ASAAS_BALANCE_ERROR });
    }
  });
}

// ─── Fiscal Config ───

function callGetFiscalInfo(professionalId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetFiscalInfo`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getFiscalInfoRequest() {
  yield takeLatest(actions.GET_FISCAL_INFO_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetFiscalInfo, professionalId, idToken);
      yield put({
        type: actions.GET_FISCAL_INFO_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.GET_FISCAL_INFO_ERROR });
    }
  });
}

function callSaveFiscalInfo(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasSaveFiscalInfo`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* saveFiscalInfoRequest() {
  yield takeLatest(actions.SAVE_FISCAL_INFO_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callSaveFiscalInfo,
        { professionalId, ...action.payload },
        idToken,
      );
      yield put({
        type: actions.SAVE_FISCAL_INFO_SUCCESS,
        payload: response.data,
      });
      notification('success', 'Dados fiscais salvos com sucesso.');
    } catch (error) {
      console.warn(error);
      const errors = error?.response?.data?.errors;
      const errorDescriptions = Array.isArray(errors) && errors.length > 0
        ? (
          <ul style={{ margin: 0, paddingLeft: 16 }}>
            {errors.map((e) => <li key={uuidv1()}>{e.description}</li>)}
          </ul>
        )
        : null;
      notification('error', 'Erro ao salvar dados fiscais.', errorDescriptions);
      yield put({ type: actions.SAVE_FISCAL_INFO_ERROR });
    }
  });
}

function callGetMunicipalOptions(professionalId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetMunicipalOptions`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getMunicipalOptionsRequest() {
  yield takeLatest(actions.GET_MUNICIPAL_OPTIONS_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetMunicipalOptions, professionalId, idToken);
      yield put({
        type: actions.GET_MUNICIPAL_OPTIONS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.GET_MUNICIPAL_OPTIONS_ERROR });
    }
  });
}

function callListMunicipalServices(professionalId, description, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasListMunicipalServices`,
    {
      professionalId,
      description: description || '',
    },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* listMunicipalServicesRequest() {
  yield takeLatest(actions.LIST_MUNICIPAL_SERVICES_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const { description } = action.payload;
      const response = yield call(
        callListMunicipalServices,
        professionalId,
        description,
        idToken,
      );
      yield put({
        type: actions.LIST_MUNICIPAL_SERVICES_SUCCESS,
        payload: response?.data?.data || [],
      });
    } catch (error) {
      yield put({ type: actions.LIST_MUNICIPAL_SERVICES_ERROR });
    }
  });
}

// ─── Invoice Defaults ───

function callGetInvoiceDefaults(professionalId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetInvoiceDefaults`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getInvoiceDefaultsRequest() {
  yield takeLatest(actions.GET_INVOICE_DEFAULTS_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetInvoiceDefaults, professionalId, idToken);
      yield put({
        type: actions.GET_INVOICE_DEFAULTS_SUCCESS,
        payload: response.data?.invoiceDefaults || null,
      });
    } catch (error) {
      notification('error', 'Erro ao carregar os padrões de NF.');
      yield put({ type: actions.GET_INVOICE_DEFAULTS_ERROR });
    }
  });
}

function callSaveInvoiceDefaults(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasSaveInvoiceDefaults`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* saveInvoiceDefaultsRequest() {
  yield takeLatest(actions.SAVE_INVOICE_DEFAULTS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callSaveInvoiceDefaults,
        { professionalId, ...action.payload },
        idToken,
      );
      yield all([
        put({
          type: actions.SAVE_INVOICE_DEFAULTS_SUCCESS,
          payload: response.data?.invoiceDefaults || action.payload,
        }),
        put({
          type: actions.LOAD_ASAAS_ACCOUNT_REQUEST,
        }),
      ]);
      notification('success', 'Padrões de NF salvos com sucesso.');
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao salvar padrões de NF.';
      notification('error', message);
      yield put({ type: actions.SAVE_INVOICE_DEFAULTS_ERROR });
    }
  });
}

// ─── Notification Defaults & Customers ───

function callGetNotificationDefaults(professionalId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetNotificationDefaults`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getNotificationDefaultsRequest() {
  yield takeLatest(actions.GET_NOTIFICATION_DEFAULTS_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetNotificationDefaults, professionalId, idToken);
      yield put({
        type: actions.GET_NOTIFICATION_DEFAULTS_SUCCESS,
        payload: {
          notificationDefaults: response.data?.notificationDefaults || null,
          messagingFees: response.data?.messagingFees || null,
        },
      });
    } catch (error) {
      yield put({ type: actions.GET_NOTIFICATION_DEFAULTS_ERROR });
    }
  });
}

function callSaveNotificationDefaults(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasSaveNotificationDefaults`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* saveNotificationDefaultsRequest() {
  yield takeLatest(actions.SAVE_NOTIFICATION_DEFAULTS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const { applyToExisting, ...defaults } = action.payload;
      const response = yield call(
        callSaveNotificationDefaults,
        { professionalId, ...defaults },
        idToken,
      );
      yield all([
        put({
          type: actions.SAVE_NOTIFICATION_DEFAULTS_SUCCESS,
          payload: response.data?.notificationDefaults || defaults,
        }),
        put({
          type: actions.LOAD_ASAAS_ACCOUNT_REQUEST,
        }),
      ]);
      notification('success', 'Padrão de notificações salvo com sucesso.');
      if (applyToExisting) {
        yield put({ type: actions.APPLY_NOTIFICATION_DEFAULTS_REQUEST });
      }
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao salvar o padrão de notificações.';
      notification('error', message);
      yield put({ type: actions.SAVE_NOTIFICATION_DEFAULTS_ERROR });
    }
  });
}

function callApplyNotificationDefaults(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasApplyNotificationDefaults`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* applyNotificationDefaultsRequest() {
  yield takeLatest(actions.APPLY_NOTIFICATION_DEFAULTS_REQUEST, function* () {
    try {
      const professionalId = yield select(getWalletOwnerId);
      let offset = 0;
      let totalCount = 0;
      let succeeded = 0;
      let failed = 0;
      let complete = false;
      while (!complete) {
        const idToken = yield call(getIdToken);
        const response = yield call(
          callApplyNotificationDefaults,
          { professionalId, offset },
          idToken,
        );
        const data = response.data || {};
        succeeded += data.succeeded || 0;
        failed += data.failed || 0;
        totalCount = data.totalCount || totalCount;
        offset = data.nextOffset ?? offset + (data.processed || 0);
        complete = data.complete !== false;
        yield put({
          type: actions.APPLY_NOTIFICATION_DEFAULTS_PROGRESS,
          payload: {
            processed: offset, totalCount, succeeded, failed,
          },
        });
      }
      yield put({ type: actions.APPLY_NOTIFICATION_DEFAULTS_SUCCESS });
      if (failed > 0) {
        notification('warning', `Padrão aplicado a ${succeeded} paciente(s); falhou em ${failed}.`);
      } else {
        notification('success', `Padrão aplicado a ${succeeded} paciente(s).`);
      }
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao aplicar o padrão aos pacientes existentes.';
      notification('error', message);
      yield put({ type: actions.APPLY_NOTIFICATION_DEFAULTS_ERROR });
    }
  });
}

function callListAsaasCustomers(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasListCustomers`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* listAsaasCustomersRequest() {
  yield takeLatest(actions.LIST_ASAAS_CUSTOMERS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callListAsaasCustomers,
        { professionalId, ...action.payload },
        idToken,
      );
      yield put({
        type: actions.LIST_ASAAS_CUSTOMERS_SUCCESS,
        payload: response.data || {},
      });
    } catch (error) {
      notification('error', 'Erro ao carregar os pacientes da carteira.');
      yield put({ type: actions.LIST_ASAAS_CUSTOMERS_ERROR });
    }
  });
}

function callSyncAsaasCustomer(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasSyncCustomer`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* syncAsaasCustomerRequest() {
  yield takeLatest(actions.SYNC_ASAAS_CUSTOMER_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callSyncAsaasCustomer,
        { professionalId, customerId: action.payload.customerId },
        idToken,
      );
      yield put({
        type: actions.SYNC_ASAAS_CUSTOMER_SUCCESS,
        payload: { customer: response.data?.customer || null },
      });
      if (response.data?.synced) {
        notification('success', 'Dados do paciente sincronizados com a carteira.');
      } else {
        notification('warning', 'Este cliente não tem vínculo com uma ficha de paciente.');
      }
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao sincronizar os dados do paciente.';
      notification('error', message);
      yield put({ type: actions.SYNC_ASAAS_CUSTOMER_ERROR });
    }
  });
}

function callGetCustomerNotifications(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetCustomerNotifications`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getCustomerNotificationsRequest() {
  yield takeLatest(actions.GET_CUSTOMER_NOTIFICATIONS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callGetCustomerNotifications,
        { professionalId, customerId: action.payload.customerId },
        idToken,
      );
      yield put({
        type: actions.GET_CUSTOMER_NOTIFICATIONS_SUCCESS,
        payload: response.data?.notifications || [],
      });
    } catch (error) {
      notification('error', 'Erro ao carregar as notificações do paciente.');
      yield put({ type: actions.GET_CUSTOMER_NOTIFICATIONS_ERROR });
    }
  });
}

function callUpdateCustomerNotifications(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasUpdateCustomerNotifications`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* updateCustomerNotificationsRequest() {
  yield takeLatest(actions.UPDATE_CUSTOMER_NOTIFICATIONS_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callUpdateCustomerNotifications,
        { professionalId, ...action.payload },
        idToken,
      );
      yield put({
        type: actions.UPDATE_CUSTOMER_NOTIFICATIONS_SUCCESS,
        payload: {
          customerId: action.payload.customerId,
          notificationDisabled: response.data?.notificationDisabled,
        },
      });
      notification('success', 'Notificações do paciente atualizadas.');
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao atualizar as notificações do paciente.';
      notification('error', message);
      yield put({ type: actions.UPDATE_CUSTOMER_NOTIFICATIONS_ERROR });
    }
  });
}

function callGetAccountFees(professionalId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetAccountFees`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getAccountFeesRequest() {
  yield takeLatest(actions.GET_ACCOUNT_FEES_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetAccountFees, professionalId, idToken);
      yield put({
        type: actions.GET_ACCOUNT_FEES_SUCCESS,
        payload: response.data?.fees || null,
      });
    } catch (error) {
      yield put({ type: actions.GET_ACCOUNT_FEES_ERROR });
    }
  });
}

// ─── Invoice Operations ───

function updatePatientOnDB(patientId, patientData, mainUser, unified, addressUid) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    ({ uid } = auth.currentUser);
  }
  let patientPath;
  if (unified?.id && unified.address?.some((a) => a === addressUid)) {
    patientPath = `/unified/${unified.id}/patients/${patientId}`;
  } else {
    patientPath = `/users/${uid}/patients/${patientId}`;
  }
  return update(dbRef(db, patientPath), patientData);
}

function callCreateInvoice(payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasCreateInvoice`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* createInvoiceRequest() {
  yield takeLatest(actions.CREATE_INVOICE_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const addressId = yield select(getSelectedAddressFromStore);

      const {
        patientId, cpf, email, mobile, cep: patientCep,
        address, addressNumber, city, state,
      } = action.payload;
      if (patientId) {
        const mainUser = yield select(getMainUserFromStore);
        const unified = yield select(getUnifiedFromStore);
        yield call(updatePatientOnDB, patientId, {
          cpf: cpf ? cpf.replace(/\D/g, '') : '',
          email: email || '',
          mobile: mobile || '',
          cep: patientCep ? patientCep.replace(/\D/g, '') : '',
          address: address || '',
          addressNumber: addressNumber || '',
          city: city || '',
          state: state || '',
        }, mainUser, unified, addressId);
      }

      const response = yield call(
        callCreateInvoice,
        {
          professionalId,
          addressId,
          ...action.payload,
        },
        idToken,
      );
      yield put({
        type: actions.CREATE_INVOICE_SUCCESS,
        payload: response.data,
      });
      notification('success', 'Nota fiscal emitida com sucesso.');
    } catch (error) {
      console.warn(error);
      const msg = 'Erro ao emitir nota fiscal.';
      const rawErrors = error?.response?.data?.errors;
      let desc;
      if (rawErrors?.length > 0) {
        rawErrors.forEach((el) => {
          if (el.code === 'invalid_action') {
            desc = (
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {el.description.split(';').map((e) => <li key={uuidv1()}>{e.trim()}</li>)}
              </ul>
            );
          }
        });
      }
      notification('error', msg, desc);
      yield put({ type: actions.CREATE_INVOICE_ERROR });
    }
  });
}

function callGetInvoice(professionalId, invoiceId, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetInvoice`,
    { professionalId, invoiceId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getInvoiceRequest() {
  yield takeLatest(actions.GET_INVOICE_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const { invoiceId } = action.payload;
      const response = yield call(callGetInvoice, professionalId, invoiceId, idToken);
      yield put({
        type: actions.GET_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao buscar nota fiscal.';
      notification('error', message);
      yield put({ type: actions.GET_INVOICE_ERROR });
    }
  });
}

function callListInvoices(professionalId, params, idToken) {
  const {
    offset = 0, limit = 10, status, effectiveDateGE, effectiveDateLE,
  } = params;
  const payload = { professionalId, offset, limit };
  if (status) payload.status = status;
  if (effectiveDateGE) payload.effectiveDateGE = effectiveDateGE;
  if (effectiveDateLE) payload.effectiveDateLE = effectiveDateLE;
  return axios.post(
    `${ROOT_URL}/asaasListInvoices`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* listInvoicesRequest() {
  yield takeLatest(actions.LIST_INVOICES_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(
        callListInvoices,
        professionalId,
        action.payload || {},
        idToken,
      );
      yield put({
        type: actions.LIST_INVOICES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: actions.LIST_INVOICES_ERROR });
    }
  });
}

function callUpdateCommercialInfo(professionalId, payload, idToken) {
  return axios.post(
    `${ROOT_URL}/asaasUpdateCommercialInfo`,
    {
      professionalId,
      formData: { ...payload },
    },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* updateCommercialInfoRequest() {
  yield takeLatest(actions.UPDATE_COMMERCIAL_INFO_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const user = yield select(getUserFromStore);
      yield call(callUpdateCommercialInfo, user.uid, action.payload, idToken);
      yield put({ type: actions.UPDATE_COMMERCIAL_INFO_SUCCESS });
      if (action.meta?.context === 'annualConfirmation') {
        notification('success', 'Dados comerciais confirmados com sucesso!');
      } else {
        notification('success', 'Dados atualizados com sucesso! Sua conta foi atualizada para Pessoa Jurídica.');
      }
      yield put({ type: actions.LOAD_ASAAS_ACCOUNT_REQUEST });
    } catch (error) {
      console.warn(error);
      const errors = error?.response?.data?.errors;
      const errorDescriptions = Array.isArray(errors) && errors.length > 0
        ? (
          <ul style={{ margin: 0, paddingLeft: 16 }}>
            {errors.map((e) => <li key={uuidv1()}>{e.description}</li>)}
          </ul>
        )
        : null;
      notification('error', 'Erro ao atualizar dados comerciais.', errorDescriptions);
      yield put({ type: actions.UPDATE_COMMERCIAL_INFO_ERROR, payload: errorDescriptions || 'Erro ao atualizar dados comerciais.' });
    }
  });
}

// ─── Invoice Patient ───

function fetchPatientFromDB(patientId, mainUser, unified, addressUid) {
  const db = getDatabase();
  const rootRef = dbRef(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    ({ uid } = auth.currentUser);
  }
  if (unified?.id && unified.address?.some((a) => a === addressUid)) {
    return get(child(rootRef, `/unified/${unified.id}/patients/${patientId}`));
  }
  return get(child(rootRef, `/users/${uid}/patients/${patientId}`));
}

export function* fetchInvoicePatientRequest() {
  yield takeLatest(actions.FETCH_INVOICE_PATIENT_REQUEST, function* (action) {
    try {
      const { patientId } = action.payload;
      const mainUser = yield select(getMainUserFromStore);
      const unified = yield select(getUnifiedFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const snap = yield call(fetchPatientFromDB, patientId, mainUser, unified, addressUid);
      yield put({
        type: actions.FETCH_INVOICE_PATIENT_SUCCESS,
        payload: snap.val() || null,
      });
    } catch (error) {
      notification('error', 'Erro ao carregar a ficha do paciente.');
      yield put({ type: actions.FETCH_INVOICE_PATIENT_ERROR });
    }
  });
}

// ─── Invoice Procedures (descrição dinâmica da NF) ───

function fetchProceduresFromDB(sourceId, mainUser, addressUid) {
  const db = getDatabase();
  const rootRef = dbRef(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    ({ uid } = auth.currentUser);
  }
  return get(child(rootRef, `/finalizedAppointments/${uid}/${addressUid}/${sourceId}/proceduresArr`));
}

export function* fetchInvoiceProceduresRequest() {
  yield takeLatest(actions.FETCH_INVOICE_PROCEDURES_REQUEST, function* (action) {
    try {
      const { sourceId, sourceType } = action.payload;
      // Só atendimentos têm procedimentos; charges antigas não gravavam sourceType
      if (!sourceId || (sourceType && sourceType !== 'appointment')) {
        yield put({ type: actions.FETCH_INVOICE_PROCEDURES_SUCCESS, payload: null });
        return;
      }
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const snap = yield call(fetchProceduresFromDB, sourceId, mainUser, addressUid);
      yield put({
        type: actions.FETCH_INVOICE_PROCEDURES_SUCCESS,
        payload: snap.val() || null,
      });
    } catch (error) {
      yield put({ type: actions.FETCH_INVOICE_PROCEDURES_ERROR });
    }
  });
}

// ─── Transfers (Saque) ───

function callCreateTransfer(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasCreateTransfer`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function callListTransfers(idToken, { startDate, endDate } = {}) {
  return axios.post(
    `${ROOT_URL}/asaasListTransfers`,
    { startDate, endDate },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* createTransferRequest() {
  yield takeLatest(actions.CREATE_TRANSFER_REQUEST, function* ({ payload }) {
    try {
      const idToken = yield call(getIdToken);
      yield call(callCreateTransfer, idToken, payload);
      yield put({ type: actions.CREATE_TRANSFER_SUCCESS });
      notification('success', 'Saque via PIX solicitado com sucesso!');
    } catch (error) {
      console.warn(error);
      const errorMsg = error.response?.data?.errors?.[0]?.description
        || error.response?.data?.message
        || 'Erro ao realizar saque.';
      const msg = 'Erro ao realizar saque.';
      const rawErrors = error?.response?.data?.errors;
      let desc;
      if (rawErrors?.length > 0) {
        rawErrors.forEach((el) => {
          if (el.code === 'invalid_action') {
            desc = (
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {el.description.split(';').map((e) => <li key={uuidv1()}>{e.trim()}</li>)}
              </ul>
            );
          }
        });
      }
      notification('error', msg, desc);

      yield put({ type: actions.CREATE_TRANSFER_ERROR, payload: errorMsg });
    }
  });
}

function callListFinancialTransactions(idToken, {
  startDate, finishDate, offset, limit, professionalId,
} = {}) {
  return axios.post(
    `${ROOT_URL}/asaasGetFinancialTransactions`,
    {
      startDate, finishDate, offset, limit, professionalId,
    },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* listFinancialTransactionsRequest() {
  yield takeLatest(actions.LIST_FINANCIAL_TRANSACTIONS_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const { fetchAll, ...params } = payload;
      params.professionalId = professionalId;
      if (!fetchAll) {
        const response = yield call(callListFinancialTransactions, idToken, params);
        yield put({
          type: actions.LIST_FINANCIAL_TRANSACTIONS_SUCCESS,
          payload: response.data,
        });
        return;
      }
      // Extrato completo do período: pagina até o teto p/ totais e saldos exatos
      const pageSize = 100;
      const maxRows = 500;
      let offset = 0;
      let totalCount = 0;
      const data = [];
      do {
        const response = yield call(callListFinancialTransactions, idToken, {
          ...params, offset, limit: pageSize,
        });
        data.push(...(response.data.data || []));
        totalCount = response.data.totalCount || data.length;
        offset += pageSize;
      } while (offset < totalCount && offset < maxRows);
      yield put({
        type: actions.LIST_FINANCIAL_TRANSACTIONS_SUCCESS,
        payload: { data, totalCount },
      });
    } catch (error) {
      yield put({ type: actions.LIST_FINANCIAL_TRANSACTIONS_ERROR });
    }
  });
}

export function* listTransfersRequest() {
  yield takeLatest(actions.LIST_TRANSFERS_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callListTransfers, idToken, { ...payload, professionalId });
      yield put({
        type: actions.LIST_TRANSFERS_SUCCESS,
        payload: response.data.data || [],
      });
    } catch (error) {
      yield put({ type: actions.LIST_TRANSFERS_ERROR });
    }
  });
}

// ─── Chave PIX de saque (Segurança) ───

function callSaveWithdrawPixKey(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasSaveWithdrawPixKey`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* saveWithdrawPixKeyRequest() {
  yield takeLatest(actions.SAVE_WITHDRAW_PIX_KEY_REQUEST, function* ({ payload }) {
    try {
      const idToken = yield call(getIdToken);
      const response = yield call(callSaveWithdrawPixKey, idToken, payload);
      yield all([
        put({
          type: actions.SAVE_WITHDRAW_PIX_KEY_SUCCESS,
          payload: response.data?.withdrawPixKey || null,
        }),
        put({ type: actions.LOAD_ASAAS_ACCOUNT_REQUEST }),
        put({ type: actions.GET_WITHDRAW_KEY_HISTORY_REQUEST }),
      ]);
      notification('success', 'Chave PIX de saque salva com sucesso.');
    } catch (error) {
      const message = error.response?.data?.errors?.[0]?.description
        || 'Erro ao salvar a chave PIX de saque.';
      notification('error', message);
      yield put({ type: actions.SAVE_WITHDRAW_PIX_KEY_ERROR, payload: message });
    }
  });
}

function callGetWithdrawKeyHistory(idToken) {
  return axios.post(
    `${ROOT_URL}/asaasGetWithdrawKeyHistory`,
    {},
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* getWithdrawKeyHistoryRequest() {
  yield takeLatest(actions.GET_WITHDRAW_KEY_HISTORY_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const response = yield call(callGetWithdrawKeyHistory, idToken);
      yield put({
        type: actions.GET_WITHDRAW_KEY_HISTORY_SUCCESS,
        payload: response.data?.items || [],
      });
    } catch (error) {
      yield put({ type: actions.GET_WITHDRAW_KEY_HISTORY_ERROR });
    }
  });
}

export function* lookupWithdrawPixKeyRequest() {
  yield takeLatest(actions.LOOKUP_WITHDRAW_PIX_KEY_REQUEST, function* ({ payload }) {
    try {
      const idToken = yield call(getIdToken);
      const response = yield call(callSaveWithdrawPixKey, idToken, { ...payload, dryRun: true });
      yield put({
        type: actions.LOOKUP_WITHDRAW_PIX_KEY_SUCCESS,
        payload: response.data?.preview || null,
      });
    } catch (error) {
      const message = error.response?.data?.errors?.[0]?.description
        || 'Não foi possível consultar a chave PIX agora.';
      yield put({ type: actions.LOOKUP_WITHDRAW_PIX_KEY_ERROR, payload: message });
    }
  });
}

// ─── Anticipations (Antecipação de Recebíveis) ───

function callSimulateAnticipation(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasSimulateAnticipation`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function callRequestAnticipation(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasRequestAnticipation`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function callListAnticipations(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasListAnticipations`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function callGetAnticipationLimits(idToken, professionalId) {
  return axios.post(
    `${ROOT_URL}/asaasGetAnticipationLimits`,
    { professionalId },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

function callCancelAnticipation(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasCancelAnticipation`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* simulateAnticipationRequest() {
  yield takeLatest(actions.SIMULATE_ANTICIPATION_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callSimulateAnticipation, idToken, { ...payload, professionalId });
      yield put({
        type: actions.SIMULATE_ANTICIPATION_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      const errorMsg = error?.response?.data?.errors?.[0]?.description || 'Erro ao simular antecipação';
      yield put({ type: actions.SIMULATE_ANTICIPATION_ERROR, payload: errorMsg });
    }
  });
}

export function* requestAnticipationRequest() {
  yield takeLatest(actions.REQUEST_ANTICIPATION_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callRequestAnticipation, idToken, { ...payload, professionalId });
      yield put({
        type: actions.REQUEST_ANTICIPATION_SUCCESS,
        payload: response.data,
      });
      notification('success', 'Antecipação solicitada', 'Sua solicitação de antecipação foi enviada com sucesso.');
      yield all([
        put({ type: actions.LIST_ANTICIPATIONS_REQUEST, payload: {} }),
        put({ type: actions.GET_ANTICIPATION_LIMITS_REQUEST }),
        put({ type: actions.SIMULATE_ANTICIPATION_CLEAR }),
      ]);
    } catch (error) {
      const errorMsg = error?.response?.data?.errors?.[0]?.description || 'Erro ao solicitar antecipação';
      yield put({ type: actions.REQUEST_ANTICIPATION_ERROR, payload: errorMsg });
    }
  });
}

export function* listAnticipationsRequest() {
  yield takeLatest(actions.LIST_ANTICIPATIONS_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callListAnticipations, idToken, { ...payload, professionalId });
      yield put({
        type: actions.LIST_ANTICIPATIONS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: actions.LIST_ANTICIPATIONS_ERROR });
    }
  });
}

export function* getAnticipationLimitsRequest() {
  yield takeLatest(actions.GET_ANTICIPATION_LIMITS_REQUEST, function* () {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      const response = yield call(callGetAnticipationLimits, idToken, professionalId);
      yield put({
        type: actions.GET_ANTICIPATION_LIMITS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: actions.GET_ANTICIPATION_LIMITS_ERROR });
    }
  });
}

export function* cancelAnticipationRequest() {
  yield takeLatest(actions.CANCEL_ANTICIPATION_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const professionalId = yield select(getWalletOwnerId);
      yield call(callCancelAnticipation, idToken, { ...payload, professionalId });
      yield put({ type: actions.CANCEL_ANTICIPATION_SUCCESS });
      notification('success', 'Antecipação cancelada', 'A antecipação foi cancelada com sucesso.');
      yield all([
        put({ type: actions.LIST_ANTICIPATIONS_REQUEST, payload: {} }),
        put({ type: actions.GET_ANTICIPATION_LIMITS_REQUEST }),
      ]);
    } catch (error) {
      const errorMsg = error?.response?.data?.errors?.[0]?.description || 'Erro ao cancelar antecipação';
      notification('error', 'Erro ao cancelar', errorMsg);
      yield put({ type: actions.CANCEL_ANTICIPATION_ERROR });
    }
  });
}

// ─── Acesso de secretárias (walletAccess) ───

function callSaveWalletAccess(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasSaveWalletAccess`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* saveWalletAccessRequest() {
  yield takeLatest(actions.SAVE_WALLET_ACCESS_REQUEST, function* ({ payload }) {
    try {
      const idToken = yield call(getIdToken);
      const response = yield call(callSaveWalletAccess, idToken, payload);
      const user = yield select(getUserFromStore);
      yield put({
        type: actions.SAVE_WALLET_ACCESS_SUCCESS,
        payload: {
          ownerUid: user?.uid,
          walletAccess: response.data?.walletAccess || payload.walletAccess,
        },
      });
      notification('success', 'Permissões de acesso salvas.');
      yield put({ type: actions.LOAD_ASAAS_ACCOUNT_REQUEST });
    } catch (error) {
      const message = error?.response?.data?.errors?.[0]?.description
        || 'Não foi possível salvar as permissões. Tente novamente.';
      notification('error', message);
      yield put({ type: actions.SAVE_WALLET_ACCESS_ERROR, payload: message });
    }
  });
}

function callGetWalletAudit(idToken, payload) {
  return axios.post(
    `${ROOT_URL}/asaasGetWalletAudit`,
    payload,
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
}

export function* loadWalletAuditRequest() {
  yield takeLatest(actions.LOAD_WALLET_AUDIT_REQUEST, function* ({ payload = {} }) {
    try {
      const idToken = yield call(getIdToken);
      const response = yield call(callGetWalletAudit, idToken, payload);
      yield put({
        type: actions.LOAD_WALLET_AUDIT_SUCCESS,
        payload: response.data?.entries || [],
      });
    } catch (error) {
      yield put({ type: actions.LOAD_WALLET_AUDIT_ERROR });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getAsaasAccountRequest),
    fork(setupAsaasAccountRequest),
    fork(discardRejectedAccountRequest),
    fork(getAsaasAccountStatusRequest),
    fork(searchZipCodeRequest),
    fork(getAsaasFeesRequest),
    fork(cancelAsaasChargeRequest),
    fork(refundAsaasChargeRequest),
    fork(loadAsaasChargesRequest),
    fork(getCheckoutInfoRequest),
    fork(validateCheckoutCpfRequest),
    fork(asaasCheckoutPayWithCreditCardRequest),
    fork(createCheckoutChargeRequest),
    fork(simulateAsaasPaymentRequest),
    fork(loadAsaasBalanceRequest),
    fork(getFiscalInfoRequest),
    fork(saveFiscalInfoRequest),
    fork(getMunicipalOptionsRequest),
    fork(listMunicipalServicesRequest),
    fork(getInvoiceDefaultsRequest),
    fork(saveInvoiceDefaultsRequest),
    fork(getNotificationDefaultsRequest),
    fork(saveNotificationDefaultsRequest),
    fork(applyNotificationDefaultsRequest),
    fork(listAsaasCustomersRequest),
    fork(syncAsaasCustomerRequest),
    fork(getCustomerNotificationsRequest),
    fork(updateCustomerNotificationsRequest),
    fork(getAccountFeesRequest),
    fork(fetchInvoicePatientRequest),
    fork(fetchInvoiceProceduresRequest),
    fork(createInvoiceRequest),
    fork(getInvoiceRequest),
    fork(listInvoicesRequest),
    fork(updateCommercialInfoRequest),
    fork(createTransferRequest),
    fork(listTransfersRequest),
    fork(saveWithdrawPixKeyRequest),
    fork(lookupWithdrawPixKeyRequest),
    fork(getWithdrawKeyHistoryRequest),
    fork(listFinancialTransactionsRequest),
    fork(checkRefundStatusRequest),
    fork(simulateAnticipationRequest),
    fork(requestAnticipationRequest),
    fork(listAnticipationsRequest),
    fork(getAnticipationLimitsRequest),
    fork(cancelAnticipationRequest),
    fork(saveWalletAccessRequest),
    fork(loadWalletAuditRequest),
  ]);
}
